import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "antd";
import CustomTable from "../../../../components/shared/table/Table.jsx";
import CustomTab from "../../../../components/shared/tab/TabComponent.jsx";
import { getUsersColumns } from "../Columns/userColumns.jsx";
import { getCoursesColumns } from "../Columns/courseColumns.jsx";
import { getBundlesColumns } from "../Columns/BundleColumns.jsx";
import { getGroupsColumns } from "../Columns/GroupColumns.jsx";

const RecentDataTabs = ({
  recentUserList,
  recentCourseList,
  recentBundleList,
  recentGroupList,
  loading,
}) => {
  const navigate = useNavigate();

  const tablist = [
    {
      key: "1",
      label: "Recent Users",
      children: (
        <CustomTable
          columns={getUsersColumns((id, name) =>
            navigate(`/users/user-history/${id}`)
          )}
          data={recentUserList}
          pagination={false}
          showLoader={loading}
          bordered
          rowKey="userId"
        />
      ),
    },
    {
      key: "2",
      label: "Recent Courses",
      children: (
        <CustomTable
          columns={getCoursesColumns((id, title) =>
            navigate(`/books/course-content/${id}`)
          )}
          data={recentCourseList}
          pagination={false}
          showLoader={loading}
          bordered
          rowKey="courseId"
        />
      ),
    },
    {
      key: "3",
      label: "Recent Curriculums",
      children: (
        <CustomTable
          columns={getBundlesColumns((id, name) =>
            navigate(`/bundles-history/${id}`, { state: { bundleName: name } }) 
          )}
          data={recentBundleList}
          pagination={false}
          showLoader={loading}
          bordered
          rowKey="bundleId"
        />
      ),
    },
    {
      key: "4",
      label: "Recent Groups",
      children: (
        <CustomTable
          columns={getGroupsColumns((id, name) => navigate(`/group-history/${id}`, { state: { name } }))}
          data={recentGroupList}
          pagination={false}
          showLoader={loading}
          bordered
          rowKey="groupId"
        />
      ),
    },
  ];

  return (
    <Card className="rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.09)] w-full">
      <CustomTab entries={tablist} />
    </Card>
  );
};

export default RecentDataTabs;